import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { PetNamesScreen, PetNamesScreenProps } from 'shared/screens/pet-names';

export function PetNamesPage(props: PetNamesScreenProps) {
  const { t } = useTranslation('screens');
  const page = props.gender ? `${props.animal}_${props.gender}` : props.animal;

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.forPage(t(`pet_names.pages.${page}.title`), t(`pet_names.pages.${page}.description`))
      }
    >
      <PetNamesScreen {...props} />
    </Page>
  );
}
